function transformMarkingArrToObj(items) {
  const result = {};

  items.forEach((item) => {
    const { key, view_only } = item;

    // Set the key to `true` if `view_only` is not present or is `false`
    result[key] = !view_only;

    // Add the "view_only" version if `view_only` exists
    if (view_only) {
      result[`${key}_view_only`] = true;
    }
  });

  return result;
}

export default transformMarkingArrToObj;
